import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useMemo, useState } from "react";
import { borderRadius as borderRadiusToken, ThemeProvider } from "@m/alchemy-theme";
import ResizeObserver from "resize-observer-polyfill";
import * as Styled from "./PopperBox.styled";
export const PopperBox = forwardRef((props, ref) => {
    const { children, hasArrow, colorScheme = "alchemyLight", maxWidth = 280, overflow = "auto", widthRef, borderRadius = borderRadiusToken("extraExtraLarge"), variant = "default", accentPalette = "expressiveInformative", hasPadding = true, style, ...rest } = props;
    const maxWidthString = typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth;
    const [width, setWidth] = useState();
    // optionally sync width with target element
    useEffect(() => {
        if (!widthRef?.current) {
            return;
        }
        const widthTarget = widthRef.current;
        const updateWidth = () => {
            const { width } = widthTarget.getBoundingClientRect();
            setWidth(width);
        };
        const resizeObserver = new ResizeObserver(updateWidth);
        resizeObserver.observe(widthTarget);
        updateWidth();
        return () => {
            resizeObserver.disconnect();
        };
    }, [widthRef]);
    const styleProp = useMemo(() => {
        if (typeof width === "number") {
            return { width };
        }
        return { maxWidth: maxWidthString };
    }, [width, maxWidthString]);
    return (_jsx(ThemeProvider, { colorScheme: colorScheme, children: _jsxs(Styled.Box, { ref: ref, "data-testid": "PopperBox", style: { ...style, ...styleProp }, borderRadius: borderRadius, variant: variant, accentPalette: accentPalette, ...rest, children: [_jsx(Styled.Background, { borderRadius: borderRadius, opacity: colorScheme === "alchemyDark" ? 0.95 : 1, children: _jsx(Styled.Arrow, { "data-popper-arrow": true, "aria-hidden": "true", hasArrow: hasArrow }) }), _jsx(Styled.Content, { hasArrow: hasArrow, hasPadding: hasPadding, overflow: overflow, children: children })] }) }));
});
PopperBox.displayName = "PopperBox";
